import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import DefaultLayout from '../Layouts/DefaultLayout';

import ProductTitle from '../Components/ProductTitle';
import SupllyItem from '../Components/SupllyItem';

function App() {
    const [supply, setSupply] = useState({});
    const [loading, setLoading] = useState(true);

    const navigate = useNavigate();
    const { slug, id } = useParams();
    const accessToken = localStorage.getItem('access_token');
    const baseUrl = process.env.REACT_APP_API_URL;

    useEffect(() => {
        const fetchSupply = async () => {
            let redirected = false;

            try {
                const response = await fetch(`${baseUrl}/painel/materiais/${slug}/arquivos/${id}`, {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                });

                if (!response.ok) {
                    if (response.status === 404) {
                        navigate('/painel/', {
                            state: {
                                message: { type: 'error', text: 'Produto não encontrado!' },
                            },
                        });
                        redirected = true;
                        return;
                    }
                    throw new Error('Erro ao buscar o material.');
                }

                const data = await response.json();
                setSupply(data.material);

                await updateViews();
            } catch (error) {
                console.error('Erro na requisição de conteúdo', error);
            } finally {
                if (!redirected) {
                    setLoading(false);
                }
            }
        };

        const updateViews = async () => {
            try {
                const response = await fetch(`${baseUrl}/painel/materiais/${slug}/visualizar/material/${id}`, {
                    method: 'PUT',
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                });

                if (!response.ok) {
                    throw new Error('Erro ao atualizar progresso.');
                }
            } catch (error) {
                console.error('Erro ao atualizar visualizações', error);
            }
        };

        fetchSupply();
    }, []);

    return (
        <DefaultLayout>
            <div className="pb-4 md:pb-6 2xl:pb-10">
                <div className="grid grid-cols-12 gap-4 md:gap-6">
                    <div className="col-span-12">
                        <ProductTitle
                            productName={supply.nome}
                            loading={loading}
                            breadcrumb={[
                                { label: 'Produtos', link: `/painel/produtos/${supply.tipo_slug}/` },
                                { label: supply.produto_nome, link: `/painel/produtos/${supply.tipo_slug}/${supply.produto_slug}/` },
                                {
                                    label: supply.grupo_nome,
                                    link: `/painel/produtos/${supply.tipo_slug}/${supply.produto_slug}/materiais/${supply.grupo_slug}/`,
                                },
                            ]}
                            back={`/painel/produtos/${supply.tipo_slug}/${supply.produto_slug}`}
                        />

                        <SupllyItem supply={supply} loading={loading} />
                    </div>
                </div>
            </div>
        </DefaultLayout>
    );
}

export default App;
